import type { ChecklistItemStatus, FinancingStatus } from './financing-api';

/** What the state means to somebody at the counter, not what the enum is called. */
export const FINANCING_STATUS_LABEL: Record<FinancingStatus, string> = {
  PENDING: 'Collecting documents',
  SUBMITTED: 'With the bank',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  WITHDRAWN: 'Withdrawn',
};

export const CHECKLIST_ITEM_LABEL: Record<ChecklistItemStatus, string> = {
  PENDING: 'Not yet',
  RECEIVED: 'Received',
  WAIVED: 'Waived',
  NOT_APPLICABLE: 'Not applicable',
};

/** Reserved status band from antd-theme.ts, never the brand colour. */
export function financingTone(status: FinancingStatus): string | undefined {
  switch (status) {
    case 'APPROVED':
      return 'success';
    case 'SUBMITTED':
      return 'processing';
    case 'REJECTED':
      return 'error';
    case 'PENDING':
      return 'warning';
    default:
      return undefined;
  }
}

export function checklistItemTone(status: ChecklistItemStatus): string | undefined {
  switch (status) {
    case 'RECEIVED':
      return 'success';
    case 'WAIVED':
    case 'NOT_APPLICABLE':
      return 'default';
    default:
      return undefined;
  }
}

/**
 * When a wait stops being normal and starts being a problem.
 *
 * Mirrors the `financing.decision_overdue` alert rule's default threshold. The
 * rule is a row NKS can retune; this is only the colour on a screen, so it does
 * not read the rule back — but if they change one, change the other.
 */
export const SLOW_DECISION_DAYS = 14;

export function isSlow(daysAwaiting: number | null): boolean {
  return daysAwaiting !== null && daysAwaiting >= SLOW_DECISION_DAYS;
}
